export enum PaymentsEftRecordType {
  EFT = 'EFT',
  SWIFT = 'SWIFT',
  CASH = 'CASH',
  FEE = 'FEE',
  OTHER = 'OTHER'
}

export enum PaymentsEftStatementStatus {
  INITIATED = 'INITIATED',
  IN_PROGRESS = 'IN_PROGRESS',
  PROCESSED = 'PROCESSED',
  DISCARDED = 'DISCARDED',
  DUPLICATE = 'DUPLICATE',
  ERROR = 'ERROR'
}

export enum PaymentsEftRecordStatus {
  PENDING = 'PENDING',
  PROCESSED = 'PROCESSED',
  DUPLICATE = 'DUPLICATE',
  IGNORE = 'IGNORE',
  IGNORE_PROCESSED = 'IGNORE_PROCESSED',
  ERROR = 'ERROR'
}

export enum PaymentsEftStatementType {
  STANDARD_BANK_INTERNET_BANKING_CSV = 'STANDARD_BANK_INTERNET_BANKING_CSV',
  UNRECOGNISED = 'UNRECOGNISED'
}
